<template>
  <span :title="titleText">
    <img v-if="logo" :src="logo" style="height: 18px; width: auto; vertical-align: middle" />
    <md-icon v-else-if="carrierName">sailing</md-icon>
  </span>
</template>
<script>
export default {
  name: "CarrierInfo",
  props: {
    carrierShipmentId: {
      type: String,
    },
    carrierName: {
      type: String,
    },
    carrierNameId: {
      type: Number,
    },
    bookingStatus: {
      type: String,
    },
    bookingDate: {
      type: String,
    },
  },
  computed: {
    carrierNameOptions() {
      return this.$store.state.shippingData.carrierNames || [];
    },
    logo() {
      const carrier = this.carrierNameOptions.find((i) => i.id === this.carrierNameId);
      return carrier && carrier.logo;
    },
    titleText() {
      return [
        this.carrierName,
        this.carrierShipmentId ? `${this.$t("shippingPlan.carrierShipmentId")}: ${this.carrierShipmentId}` : null,
        this.bookingStatus ? `${this.$t("shippingPlan.containerBooking")}: ${this.$t(`shippingPlan.bookingStatus.${this.bookingStatus}`)}` : null,
        this.bookingDate ? `${this.$t("shippingPlan.containerBookingDate")}: ${this.$options.filters.formatDate(this.bookingDate)}` : null,
      ]
        .filter(Boolean)
        .join("\n");
    },
  },
};
</script>
<style></style>
